import { setupCache } from 'axios-cache-adapter'
import qs from 'qs'

const paramsSerializer = (params) => {
  return qs.stringify(params)
}

const cache = setupCache({
  readHeaders: true,
  debug: false,
  exclude: {
    // {Array} List of regular expressions to match against request URLs.
    paths: [],
    // {Boolean} Exclude requests with query parameters.
    query: false,
    // {Function} Method which returns a `Boolean` to determine if request
    // should be excluded from cache.
    filter: null,
    // {Array} HTTP methods which will be excluded from cache.
    // Defaults to `['post', 'patch', 'put', 'delete']`
    // Any methods listed will also trigger cache invalidation while using the default `config.invalidate` method.
    //
    // Note: the HEAD method is always excluded (hard coded).
    // the OPTIONS method is ignored by this library as it is automatically handled by browsers/clients to resolve cross-site request permissions
    methods: ['post', 'patch', 'put', 'delete'],
  },
  key: (req) =>
    req.url + paramsSerializer(req.params) + (req.headers['Accept-Language'] || req.headers['accept-language']),
})

export default async ({ $axios }, locale) => {
  if (process.server) {
    $axios.defaults.adapter = cache.adapter
  }

  try {
    const response = await $axios.get('/v2/translations?group=web', {
      headers: {
        'accept-language': locale,
      },
    })

    return {
      ...response.data,
    }
  } catch (error) {
    return {}
  }
}
